export const isEnumValue = <TEnum extends Record<string, string>>(
  enumType: TEnum,
  value?: string | null,
): value is TEnum[keyof TEnum] =>
  value ? Object.values(enumType).includes(value) : false;

export const isArrayItem = <T>(
  array: readonly T[],
  value: unknown,
): value is T => array.includes(value as T);

export const hasObjectKey = <TValue, TKey extends string>(
  obj: Record<PropertyKey, TValue> | object | unknown,
  key: TKey,
): obj is Record<TKey, TValue> => {
  return typeof obj === 'object' && obj !== null && key in obj;
};
